module.exports = __webpack_public_path__ + "static/media/vr_icon_hover.77ce50fd.svg";